module.exports = __webpack_public_path__ + "img/yashav_no.db6729b7.png";